import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "@/store/store";
import {DeliousApiClient} from "@/_global/api_clients/DeliousApiClient";
import {DeliousApiUtil} from "@/_common/api/utils/delious_api_utils";


// Deliousで保持している商品(オプション含む詳細情報)の一覧情報を格納する


@Module({
    name: "DeliousItemsStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class DeliousItemsStore extends VuexModule {

    // state
    private _apiResponse: Delious.ItemDetailListResponse = {} as any;
    private _itemById: { [itemId: number]: Delious.ItemBase } = {};
    private _condimentGroupById: { [condimentGroupId: number]: Delious.CondimentGroup } = {};

    // getter
    get all(): Delious.ItemDetailListResponse {
        return this._apiResponse.list ? this._apiResponse : {list: []};
    }

    get itemById(): { [p: number]: Delious.ItemBase } {
        return this._itemById;
    }

    get condimentGroupById(): { [p: number]: Delious.CondimentGroup } {
        return this._condimentGroupById;
    }

    @Action
    public async init(param: { storeId: number, periodId: number }) {
        const response: Delious.ItemDetailListResponse = await DeliousApiClient.getItemDetailList(param.storeId, param.periodId);

        // todo セットに対応したら消す。start （暫定的に、通常商品と固定セットだけにフィルタ）
        response.list = (response.list as Delious.ItemBase[]).filter(v => v.v2_plu_type == 0 || v.v2_plu_type == 4) as any;
        // todo セットに対応したら消す。 end

        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.list.length; i++) {
            this.setItemById(response.list[i]);
            this.setCondimentGroupById(response.list[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = {} as any;
        this._itemById = {};
        this._condimentGroupById = {};
    }

    @Mutation
    private setResponse(response: Delious.ItemDetailListResponse) {
        this._apiResponse = response;
    }

    @Mutation
    private setItemById(item: Delious.ItemBase) {
        // メイン商品
        Vue.set(this._itemById, item.plu_no, item);

        // オプション商品
        const condimentGroups = DeliousApiUtil.itemToCondimentGroups(item as Delious.Item);
        const condimentItems = DeliousApiUtil.condimentGroupsToCondimentItems(condimentGroups);
        for (let i = 0; i < condimentItems.length; i++) {
            const condimentItem = condimentItems[i];
            Vue.set(this._itemById, condimentItem.plu_no, condimentItem);
        }
    }

    @Mutation
    private setCondimentGroupById(item: Delious.ItemBase) {
        const condimentGroups = DeliousApiUtil.itemToCondimentGroups(item as Delious.Item);
        for (let i = 0; i < condimentGroups.length; i++) {
            const condimentGroup = condimentGroups[i];
            Vue.set(this._condimentGroupById, condimentGroup.condiment_group_no, condimentGroup);
        }
    }

}

export default getModule(DeliousItemsStore);
